module.exports={
    "over_size_message":"Das Bild, das Sie hochgeladen haben, ist über 10 MB groß. Wir werden Ihre Datei für das Hochladen komprimieren. Bitte klicken Sie auf \"Bestätigen\", um den Upload fortzusetzen.",
    "file_type_error":"Die Datei, die Sie hochgeladen haben, ist kein Bild! Bitte versuchen Sie erneut, eine andere Datei hochzuladen.",
    "upload_error":"Hochladen fehlgeschlagen. (Fehlercode: 2000) Bitte versuchen Sie es erneut.",
    "watermark_remove_over_size":"Das Bild, das Sie hochgeladen haben, ist über 5 MB groß. Es wird empfohlen, dass Sie unseren kostenlosen Online Image Compressor verwenden. <a class=\"jump-link\" href=\"https://www.tipard.com/de/image-compressor-online/\">Mehr erfahren</a>",
    "watermark_remove_file_type_error":"Die Datei, die Sie hochgeladen haben, ist kein Bild! Bitte versuchen Sie erneut, eine andere Datei hochzuladen.",
    "watermark_remove_image_type_error":"Das Bildformat wird nicht unterstützt. Wir unterstützen nur JPG, JPEG, PNG und BMP.",
    "watermark_remove_upload_error":"Erkennung fehlgeschlagen. (Fehlercode: 2001) Bitte versuchen Sie es erneut...",
    "watermark_remove_processing":"Bild verarbeiten...",
    "watermark_remove_not_save":"Der von Ihnen ausgewählte Bereich wird nicht beibehalten. Sind Sie sicher, dass Sie ihn zuschneiden wollen?",
    "watermark_remove_back_home":"Der aktuelle Status wird nicht gespeichert. Sind Sie sicher, dass Sie zur Startseite zurückkehren möchten?",
    "watermark_remove_new_image":"Der aktuelle Status wird nicht gespeichert. Sind Sie sicher, dass Sie ein neues Bild auswählen möchten?",
    "watermark_select":"Wählen",
    "watermark_select_area":"Bitte wählen Sie den Bereich des Wasserzeichens aus, den Sie löschen möchten, bevor Sie auf Entfernen klicken.",
    "watermark_beyond_4k":"Das ausgewählte Bild hat eine Auflösung von mehr als 4K. Es tut uns leid, dass wir es derzeit nicht verarbeiten können.",
    "watermark_beyond_pixel_1":"Das ausgewählte Bild hat eine Auflösung von mehr als <span>%spx</span><span>&times;%spx</span>. Es kann nicht verarbeitet werden. Bitte wählen Sie ein anderes aus.",
    "watermark_beyond_pixel_2":"Besucher können nur <span>%s</span> Bilder mit einer Auflösung von über <span>%spx</span>x<span>%spx</span> verarbeiten. Bitte melden Sie sich an und verwenden Sie es weiter.",
    "watermark_beyond_size_1":"Das ausgewählte Bild ist über <span>%s MB</span> groß. Es kann nicht verarbeitet werden. Bitte wählen Sie ein anderes aus.",
    "watermark_beyond_size_2":"Das ausgewählte Bild ist über <span>%s MB</span> groß. Die Besucher können jedoch nur Bilder mit einer Größe von weniger als <span>%s MB</span> verarbeiten. Bitte melden Sie sich an und verwenden Sie es weiter.",
    "no_user_down":"Besucher können nur <span>%s</span> Bilder in Originalqualität herunterladen. Bitte melden Sie sich an und fahren Sie mit dem Herunterladen fort. Sie können auch die 7-Tage-Historie nach dem Einloggen behalten. Laden Sie weiterhin Bilder herunter, die <span>%spx</span> breit oder hoch sind.",
    "no_down_rights":"Sie können keine Bilder mit Originalqualität herunterladen, bitte aktualisieren Sie Ihren Plan! Sie können auch weiterhin niedrige Qualität Bilder mit <span>%spx</span> herunterladen.",
    "error_40001":"Fehler: 40001. Bitte kontaktieren Sie uns.",
    "error_40099":"Fehler: 40099. Bitte kontaktieren Sie uns.",
    "down_btn":"Das Herunterladen wird vorbereitet, bitte warten Sie...",
    "noRemove_down_btn":"Sie haben keine Operationen durchgeführt. Bitte wählen Sie das Wasserzeichen, das Sie entfernen möchten, und klicken Sie auf die Schaltfläche Entfernen. Dann können Sie Ihr Bild herunterladen.",
    "history_open":"Des geänderte Bild wird geöffnet, bitte warten...",
    "maskRightsMonitor_info":"Die Webseite für das Upgrade Ihres Plans wurde in einer neuen Registerkarte geöffnet, und Ihr Plan wird nach dem Upgrade automatisch synchronisiert.",
    "maskLoginMonitor_info":"Die Anmeldeseite wurde geöffnet. Bitte schließen Sie die Anmeldung ab. Nach erfolgreicher Anmeldung oder Registrierung wird diese Seite automatisch synchronisiert. Bitte schließen Sie diese Seite nicht.",
    "photo_rights_info":" <span><i class=\"num\">2</i> Bilder</span> in Originalqualität können heruntergeladen werden. <a href=\"https://account.tipard.com\" target=\"_blank\">Details anzeigen>></a>",
    "rights_original":"Um die Einstellung \"Bildverbesserungsfunktion verwenden, um den Qualitätsverlust zu verringern\" zu aktivieren, müssen Sie Ihr Konto upgraden.",
    "Brush":"Pinsel",
    "Lasso":"Lasso",
    "Polygonal":"Polygonal",
    "Eraser":"Radiergummi",
    "Free":"Kostenlos",
    "More":"Mehr:",
    "Select":"Wählen",
    "Remove":"Entfernen",
    "BrushSize":"Pinselgröße:",
    "AspectRatio":"Seitenverhältnis:",
    "Upload":"Neues Foto",
    "History":"Verlauf",
    "Login":"Anmelden",
    "MyAccount":"Mein Konto",
    "Logout":"Abmelden",
    "Usinghelp":"Benutzerhilfe>>",
    "Enhancer":"Bildverbesserungsfunktion verwenden, um den Qualitätsverlust zu verringern",
    "Download":"Downloaden",
    "Guide":"Anleitung",
    "Polygonal1":"Polygonal:",
    "Polygonal_info":"Klicken Sie mit der linken Maustaste, um jeweils einen Punkt zu identifizieren.",
    "Lasso1":"Lasso:",
    "Lasso_info":"Drücken Sie die linke Maustaste lange, um den Bereich des Wasserzeichens mit dem Lasso einzufangen.",
    "Brush1":"Brush:",
    "Brush_info":"Drücken Sie die linke Maustaste lange, um genau auszuwählen.",
    "Eraser1":"Radiergummi:",
    "Eraser_info":"Löschen Sie nicht benötigte Teile aus dem ausgewählten Bereich.",
    "Click":"Klicken auf",
    "the":"den",
    "click_info":"um die Entfernung des unerwünschten Wasserzeichens zu starten.",
    "PleaseUploadImages":"Bitte laden Sie ein Bild hoch.",
    "CropInfo":"Nach dem Entfernen des Wasserzeichens können Sie auf die Schaltfläche Zuschneiden klicken, um das Bild vor dem Speichern zuzuschneiden, oder auf die Schaltfläche Herunterladen, um das aktuelle Bild direkt zu speichern.",
    "Crop":"Zuschneiden",
    "Back":"Zurück",
    "DownloadCropped":"Ausschnitt herunterladen",
    "Cancel":"Abbrechen",
    "FreeWatermarkRemover":"Free Watermark Remover",
    "Processing":"Verarbeiten...",
    "NewImage":"Neues Bild",
    "Retry":"Wiederholen",
    "Yes":"Ja",
    "No":"Nein",
    "FailureFeedback":"Fehlerrückmeldung",
    "removeTip":"Nachdem Sie den Bereich mit dem Wasserzeichen ausgewählt haben, klicken Sie auf die Schaltfläche Entfernen, um das Wasserzeichen zu löschen.",
    "rightDown":"Bilder in niedriger Qualität herunterladen",
    "history_will":"Läuft ab nach",
    "Expired":"(Abgelaufen)",
	"uploadImage":"Bild hinzufügen",
    "uploadImageInfo":"Oder ziehen Sie Ihre Bilddatei per Drag & Drop hierher, um das Wasserzeichen zu entfernen!",

    "watermark_beyond_pixel_3":"The selected image exceeds <span>%s&times;%s resolution</span>, please upgrade your plan first.",
    "watermark_beyond_size_3":"The selected image exceeds <span>%sMB</span>, please upgrade your plan first.",
    "no_user_login":"New users who login can gain THREE HD original image downloading benefits.<span class=\"loginMaskbtn\">Login immediately>></span>",
    "Unlimited":"Unbegrenzt",
    "watermark_beyond_pixel_3":"Das ausgewählte Bild überschreitet die Auflösung <span>%s&times;%s</span>. Bitte aktualisieren Sie zuerst Ihren Plan.",
    "watermark_beyond_size_3":"Das ausgewählte Bild überschreitet <span>%s MB</span>. Bitte aktualisieren Sie zuerst Ihren Plan.",
    "no_user_login":"Neue Benutzer, die sich anmelden, können zwei Bilder in HD-Größe herunterladen. Sofort anmelden>>",
    "Upgrade":"Upgrade",
    "Loading":"Laden...",
    "SelectAll":"Alles auswählen",
    "Open":"Öffnen",
    "Delete":"Löschen",
    "Clear":"Ungültig löschen",
    "noHistory":"Kein Verlauf",
    "Close":"Schließen",
    "buyUserInfo":"Herzlichen Glückwunsch! Sie haben Ihren Plan erfolgreich aktualisiert. Bitte kehren Sie zur Produktseite zurück und nutzen Sie alle Funktionen uneingeschränkt.",
    "buyNoUserInfo":"Herzlichen Glückwunsch! Sie haben Ihren Plan erfolgreich aktualisiert. Der Plan wurde an die E-Mail-Adresse gebunden, die Sie während des Upgrades angegeben haben. Bitte <span class=\"loginMaskbtn\">melden Sie sich mit der E-Mail-Adresse an</span>, um Ihren Plan zu nutzen. Wenn Sie kein Konto mit der E-Mail-Adresse registriert oder verknüpft haben, <span class=\"registerMaskbtn\">bitte verwenden Sie die E-Mail-Adresse, um ein neues Konto zu registrieren</span>.",
    "GetStarted":"Loslegen",
    "AccessTo":"Zugang zu:",
    "imagesOfwatermarkremoval":"Bilder zur Entfernung von Wasserzeichen",
    "upTo":"Bis zu",
    "perImage":"pro Bild",
    "Support":"Unterstützung",
    "resolution":"Auflösung",
    "PrepaidPackage":"Prepaid-Paket",
    "PayasYouGo":"Bezahlen wie Sie wollen",
    "TaxIncl":"inkl. Steuern",
    "Checkout":"Kaufen",
    "imagesDay":"Bilder/Tag",
    "imagesMonthly":"Bilder/Monat",
    "image":"Bild",
    "images":"Bilder",
    "imageSize":"Bildgröße",
    "buyInfo1":"Integration von Drittanbieter-<span>Enhancern</span>",
    "buyInfo2":"Der Bearbeitungsverlauf ist 7 Tage lang gültig",
    "buyInfo3":"Vorrangige Verarbeitung",
    "buyInfo4":"7x24 Kundenbetreuung",
    "buyInfo5":"Abgelaufen nach 24 Stunden",
    "buyInfo6":"Kein Abonnement. Keine automatische Erneuerung!",
    "buyInfo7":"Jederzeit verfügbar",
    "dayPlan":"1-Tages-Plan",
    "Lifetime":"Lebenslang",
    "note":"<span>Hinweis</span>: Bitte beachten Sie, dass der gekaufte Plan an die E-Mail-Adresse gebunden ist, die Sie beim Kauf angegeben haben. Um den Plan erfolgreich zu nutzen, registrieren Sie sich oder melden Sie sich mit der derselben E-Mail-Adresse an."
}